import { combineReducers } from "redux";
import appReducer from "./AppReducer";
import zoomReducer from "./ZoomReducer";
import seekerReducer from "./SeekerReducer";
import AnalyticsReducer from "./AnalyticsReducer";
import ProgramReducer from "./ProgramReducer";

const rootReducer = combineReducers({
  appReducer,
  zoomReducer,
  seekerReducer,
  AnalyticsReducer,
  ProgramReducer,


  // Add more reducers as needed
});

export default rootReducer;
